const formControls = document.querySelectorAll('.wpcf7 .form-control');

formControls.forEach((e, i) => {
    let input = formControls[i];
    let label = input.parentNode.parentNode.querySelector('label');

    input.addEventListener('focus', function() {
        this.parentNode.parentNode.classList.add('active');
    });

    input.addEventListener('blur', function() {
        let cval = this.value;

        if (cval.length < 1) {
            this.parentNode.parentNode.classList.remove('active');
        }
    });

    if (label) {
        label.addEventListener('click', function() {
            let input = this.parentNode.querySelector('.form-control');
            input.focus();
        });
    }
});

// scroll to form from modal
const formToBtb = document.querySelectorAll('.micromodal__btn-out.btn-outline');

formToBtb.forEach((button) => {
    button.addEventListener('click', el => {
        const sendTo = el.currentTarget.dataset.to;
        const sendToTextArea = document.querySelector('.form-group.area textarea');
        const offsetHeader = $('.page-header').outerHeight();

        sendToTextArea.value = `To: ${sendTo}`;
        document.querySelector('.form-group.area').classList.add('active');

        setTimeout(() => {
            $('html, body').animate({ scrollTop: $(`[data-scroll="contact-form"]`).offset().top - offsetHeader }, 1000, () => {
                let x = window.scrollX,
                    y = window.scrollY;

                window.scrollTo(x, y);
            });
        }, 500);
    });
});

document.querySelectorAll('.auto-resize').forEach(textarea => { const resize = () => { textarea.style.height = 'auto'; textarea.style.height = textarea.scrollHeight + 'px'; }; textarea.addEventListener('input', resize); resize(); });